import { MutationTree } from 'vuex'
import { Settings } from '@/store/settings/state'

export const mutations: MutationTree<Settings> = {}
